import React from 'react'
import { Container, Row, Col } from "reactstrap";

import "../Header/Header.css"

import editorial from "../../assets/images/cerroNegro-Ed.png";




const Header = () => {
  return (
    <header className="header">
      <div className="header__middle">
        < Container>
          <Row>
            {/* <Col className="col">
              <div className="logo">
                <img src={tapa} alt="tapaDelLibro" className="tapaLibro"/>
              </div>
            </Col> */}
            <Col className="col">
              <div> 
                <img src={editorial} alt="editorial" className="editorialCN"/>
              </div>
            </Col>
            
          </Row>
        </Container>
        
      </div>
    </header>
  )
}

export default Header